import { render, staticRenderFns } from "./ProCardHeader.vue?vue&type=template&id=03e0071a&scoped=true"
import script from "./ProCardHeader.vue?vue&type=script&lang=js"
export * from "./ProCardHeader.vue?vue&type=script&lang=js"
import style0 from "./ProCardHeader.vue?vue&type=style&index=0&id=03e0071a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e0071a",
  null
  
)

export default component.exports